export default {"src":"/_next/static/media/MessagesIcon.aade3e9b.svg","height":18,"width":17};